import { useQuery } from '@tanstack/react-query';

import { getCustomerDetails } from '../api/clients/company.api';
import { queryKeys } from '../api/queryKeys';

export const useCustomerDetails = (customerId) => {
    return useQuery({ queryKey: queryKeys.customerDetails(customerId), queryFn: () => getCustomerDetails(customerId) });
};
